import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClientConfigProvider } from './lib/ClientConfigContext';
import { ErrorBoundary } from './lib/errorBoundary';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/leaflet.css';
import './assets/css/style.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <ClientConfigProvider>
          <App />
        </ClientConfigProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
